import { useContext } from 'react';
import { StorageContext } from './StorageProvider';
export var useStorage = function () {
    var storageProvider = useContext(StorageContext).storage;
    return storageProvider;
};
